export const NoReportsWarning = () => {
  return <p>Has alcanzado tu límite de reportes.</p>
}
